<div class="lm-image">
  @for (col of imageColumn; track trackByIndex($index, col)) {
    <div>
      @if (col) {
        <lm-element
          [layoutObject]="col"
          [layoutInfo]="layoutInfo"
          [lmColumnLayoutInfo]="lmColumnLayoutInfo"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          [model]="model"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-element>
      }
    </div>
  }
</div>
<div class="lm-elements">
  <div class="row" [ngStyle]="{'display': !lmColumnLayoutInfo?.distributed ? 'flex' : null}">
    @for (col of columns; track trackByIndex($index, col)) {
      <div [ngClass]="{'lm-column': true, 'lm-column-distributed': lmColumnLayoutInfo?.distributed}">
        @if (col) {
          <lm-element
            [layoutObject]="col"
            [layoutInfo]="layoutInfo"
            [lmColumnLayoutInfo]="lmColumnLayoutInfo"
            [specFields]="specFields"
            [placeHolder]="placeHolder"
            [model]="model"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-element>
        }
      </div>
    }
  </div>
</div>
